export const borderedFlexBoxStyles = {
  gap: 2,
  flex: 1,
  p: 3,
  height: 'min-content',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.default,
};
